var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarMsgErroComprometimento)?_c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v("ENTREGA NÃO COMPROMETIDA. REGULARIZE A SITUAÇÃO PARA REALIZAR A APROVAÇÃO. ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }